import NotificationCore from '@/modules/NotificationCore/NotificationCore';
import TimerUtils from '@/modules/Timer/TimerUtils';
import { Component, Vue } from 'vue-property-decorator';
import { $checkAppVersion } from '../api/app-version';
import { AppVersionStatus } from '../api/interface';

@Component
export default class AppVersionController extends Vue {

	readonly appVersionCheckingIntervalInMinute: number = 5

	appVersionCheckingIntervalId: number | null = null

	created() {
		//this.startAppVersionCheckingInterval();
	}

	// startAppVersionCheckingInterval() {
	// 	this.checkAndHandleAppVersionForActually();

	// 	this.appVersionCheckingIntervalId = setInterval(
	// 		this.checkAndHandleAppVersionForActually.bind(this),
	// 		this.appVersionCheckingIntervalInMinute * TimerUtils.MS_IN_MINUTE
	// 	);
	// }

	// stopAppVersionCheckingInterval() {
	// 	this.appVersionCheckingIntervalId !== null
	// 		&& clearInterval(this.appVersionCheckingIntervalId);
	// }

	// async checkAndHandleAppVersionForActually(): Promise<boolean> {
	// 	const appVersionIsActually = await this.requestCheckAppVersionIsActually();

	// 	if (!appVersionIsActually) {
	// 		this.stopAppVersionCheckingInterval();
	// 		await this.addNotificationForUpdatingApp();
	// 	}

	// 	return appVersionIsActually;
	// }

	// async requestCheckAppVersionIsActually(): Promise<boolean> {
	// 	const response = await $checkAppVersion();

	// 	return !((response?.status === AppVersionStatus.SUPPORTED
	// 		&& response?.newVersion)
	// 		|| response?.status === AppVersionStatus.DEPRECATED);
	// }

	// async addNotificationForUpdatingApp(): Promise<number> {
	// 	return NotificationCore.addToastWithData({
	// 		text: this.$t('hasUpdate') as string,
	// 		status: 'important_light',
	// 		actionText: this.$t('update') as string,
	// 		action: () => location.reload(),
	// 		prependIconUrl: '/img/icons/refresh-time.svg',
	// 		width: 360,
	// 	}, TimerUtils.MS_IN_MINUTE * TimerUtils.MINUTE_IN_DAY);
	// }

}